<template>
    <div class="page-company">
        <el-card shadow="never" class="m-b-20">
            <el-row :gutter="20">
                <el-col :sm="24" :md="24" :lg="18" :xl="18" class="m-b-10 m-b-lg-0">
                    <el-input placeholder="Искать зону"
                              v-model="form.Search"
                              v-on:change="getData"
                              clearable>
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </el-col>
                <el-col :sm="24" :md="24" :lg="6" :xl="6" align="right" class="d-flex">
                    <el-button class="w-100" type="primary" @click="handleFilter" icon="icon-search">Поиск</el-button>
                </el-col>
            </el-row>
        </el-card>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-table v-loading="loading" :data="dataTable">
                    <el-table-column prop="ID" label="Номер" v-if="$mobile()" />
                    <el-table-column prop="Name" label="Название">
                        <template slot-scope="scope">
                            <div class="font-weight-bold">
                                <a :href="'/?ZoneID=' + scope.row.ID" class="color-black">
                                    {{ scope.row.Name }}
                                </a>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Capacity" label="Вместимость" />
                    <el-table-column prop="Occupied" label="Занято" v-if="$mobile()" />
                    <el-table-column prop="Reserved" label="Зарезервировано" v-if="$mobile()" />
                    <el-table-column prop="HandicappedTotal" label="Для инвалидов" v-if="$mobile()" />
                    <el-table-column prop="HandicappedFree" label="Для инвалидов Свободно" v-if="$mobile()" />
                    <el-table-column prop="AllowPassage" label="Проезд разрешен" v-if="$mobile()">
                        <template slot-scope="scope">
                            <div v-if="scope.row.AllowPassage" class="font-weight-bold color-success">
                                Да
                            </div>
                            <div v-else class="font-weight-bold color-danger">
                                Нет
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            fixed="right"
                            label=""
                            width="70px"
                            align="right"
                    >
                        <template slot-scope="scope">
                            <el-button icon="icon-more-hor"
                                       @click="showDetails(scope.row.ID)"
                                       class="el-button--icon"
                                       size="mini" title="Details">
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="m-t-20 text-center">
                    <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="form.Page"
                            :page-sizes="[10, 20, 100, 200, 300, 400]"
                            :page-size="form.PageSize"
                            layout="sizes, prev, pager, next"
                            :total="total">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import Vue from 'vue'

    export default {
        data () {
            return {
                loading: false,
                form: {
                    From: Vue.moment().add(-30, 'days').format('DD/MM/YYYY HH:mm'),
                    To: Vue.moment().hour('23').minutes('59').format('DD/MM/YYYY HH:mm'),
                    Search: '',
                    Page: 1,
                    PageSize: 20
                },
                total: 0,
                dataTable: [],
                tarifDict: []
            }
        },
        created () {
            this.getData()
        },
        methods: {
            changeDate (date) {
                this.form.From = date[0]
                this.form.To = date[1]
                this.getData()
            },
            handleSizeChange (val) {
                this.form.PageSize = val
                this.getData()
            },
            handleCurrentChange (val) {
                this.form.Page = val
                this.getData()
            },
            handleFilter () {
                this.getData()
            },
            getData () {
                this.loading = true

                let request = Object.assign({
                    Name: "GetItemsList",
                    ItemType: "Zone"
                }, this.form)

                this.$api.Main.getZones(request).then(response => {
                    this.loading = false
                    this.dataTable = response.Items
                    this.total = response.Total
                }).catch (() => {
                    this.loading = false
                })
            },
            showDetails (id) {
                this.$router.push({ name: 'zoneDetails', params: { id: id } })
            },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">

</style>
